var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[(_vm.isSmall)?_c('div',{staticClass:"spinner-small"}):_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }